import React from "react";
import { motion } from "framer-motion";
import { Mic2, Image as ImageIcon, ShieldCheck, Zap } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export default function Features() {
  const { t } = useI18n();
  const features = [
    { icon: Mic2, title: t("landing.feature1Title"), desc: t("landing.feature1Desc"), big: true },
    { icon: ImageIcon, title: t("landing.feature2Title"), desc: t("landing.feature2Desc") },
    { icon: ShieldCheck, title: t("landing.feature3Title"), desc: t("landing.feature3Desc") },
    { icon: Zap, title: t("landing.feature4Title"), desc: t("landing.feature4Desc") },
  ];

  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="max-w-xl font-heading text-2xl font-medium tracking-tight sm:text-3xl lg:text-4xl">
          {t("landing.featuresTitle")}
        </h2>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`rounded-2xl border border-border bg-card p-7 transition-transform hover:-translate-y-1 ${
                f.big ? "sm:col-span-2 lg:row-span-1" : ""
              }`}
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <f.icon className="h-5 w-5" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-heading text-lg font-medium">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
